// extracted by css-extract-rspack-plugin
export default {"textLinkedStyled":"OXujCxBb"};